import { DOIHeaderSelect } from "components/DOIHeaderSelect/DOIHeaderSelect";

import type { DocumentManagementDataType } from "../../../../types/DataTypes";
import { ClaimNumbersDisplay } from "../components/ClaimNumbersDisplay";
import FileNumberPill from "../components/FileNumberPill";
import ServicesPills from "../components/ServicesPills";
import type { InfoPillFields } from "../InfoPillTypes";
import {
  formatDateOfBirth,
  formatMedicareEligibilityStatus,
  getClaimNumbersString,
  getEmployerName,
  NONE,
  NOT_AVAILABLE,
} from "../InfoPillTypes";

export const getDocumentManagementInfoPillData = (
  service?: DocumentManagementDataType,
): InfoPillFields => {
  if (!service) return {};

  const fields: InfoPillFields = {
    "File #": {
      value: service?.file?.id ? (
        <FileNumberPill fileId={service.file.id} />
      ) : (
        NOT_AVAILABLE
      ),
      disableTooltip: true,
      classNames: null,
    },
    Claimant: {
      value: service?.claimant
        ? `${service.claimant.first_name} ${service.claimant.last_name}`
        : NONE,
      classNames: null,
    },
    "Claim Numbers": {
      value: <ClaimNumbersDisplay service={service} />,
      classNames: null,
      tooltip: getClaimNumbersString(
        service?.file?.claim_numbers,
        service?.file?.dates_of_injury,
      ),
      tooltipHtml: true,
    },
    Client: {
      value: service?.file?.client.name || NONE,
      classNames: null,
      action: {
        type: "drawer" as const,
        drawerType: "clientInfo" as const,
      },
    },
    DOB: {
      value: formatDateOfBirth(service?.claimant?.birth_date),
      classNames: null,
    },
    "Date of Injury": {
      value: <DOIHeaderSelect service={service} />,
      classNames: null,
      tooltip: getClaimNumbersString(
        service?.file?.claim_numbers,
        service?.file?.dates_of_injury,
      ),
      tooltipHtml: true,
    },
    Services: {
      value: service?.file?.services?.length ? (
        <ServicesPills
          services={service.file.services}
          fileId={service.file.id}
        />
      ) : (
        NOT_AVAILABLE
      ),
      disableTooltip: true,
      classNames: null,
    },
    Employer: {
      value: getEmployerName(service?.file || {}),
      classNames: null,
    },
    "Medicare Eligibility Status": {
      value: formatMedicareEligibilityStatus(
        service?.claimant?.is_medicare_eligible,
      ),
      classNames: null,
    },
    "Medicare ID": {
      value: service?.claimant?.medicare_id || NONE,
      classNames: null,
    },
    "File Adjuster": {
      value: service?.file?.adjuster?.name || NOT_AVAILABLE,
      classNames: null,
    },
  };

  return fields;
};
